import React, {useEffect} from 'react'
import {MarkdownView} from '../../common/MarkdownView'
import {highlightAll} from 'prismjs/components/prism-core'
import 'prismjs/components/prism-sql'
import {useDispatch, useSelector} from 'react-redux'
import {IReduxState} from '../../../redux/types/IReduxState'
import {taskActions} from '../redux/actions'
import {Button} from 'ac_ui'
import {TaskDto, TaskListItemDto} from 'learndb-share'

interface ITheoryProps {
  id: string
  isShowStart?: boolean
}

const Theory: React.FC<ITheoryProps> = ({isShowStart}) => {
  const taskDispatch = useDispatch()

  const themeTasks = useSelector<IReduxState, TaskListItemDto[]>((state) => state.task?.themeTasks)
  const task = useSelector<IReduxState, TaskDto>((state) => state.task?.task)
  const taskId: number = task?.taskId
  const theory: string = task?.theory
  const name: string = task?.name

  useEffect(() => {
    if (theory) {
      highlightAll()
    }
  }, [theory])

  const closeTheory = (): void => {
    taskDispatch(
      taskActions.setState({
        isDrawerModalOpen: false,
        drawerModalComponentId: null,
      }),
    )
  }

  const getTaskNumber = (): string => {
    let number
    themeTasks.forEach((themeTask, index) => {
      if (themeTask.taskId === taskId) {
        number = index + 1
      }
    })

    if (number) {
      return number + '/' + themeTasks.length
    } else {
      return ''
    }
  }

  return (
    <div className={'task-theory custom-scroll h-100 pt-x6 pb-0 pr-x1 pl-x6 mr-x1'}>
      <h2 className={'task-block-header'}>{name + ' (' + getTaskNumber() + ')'}</h2>
      <MarkdownView content={theory} className={'mb-x6'} />
      {isShowStart && (
        <div className={'start-button-container'}>
          <Button size={'md'} onClick={closeTheory}>
            Начать
          </Button>
        </div>
      )}
    </div>
  )
}

export {Theory}
